<section class="header">
  <p-menubar
    [model]="items"
    (click)="toggleMenu()"
    styleClass="flex flex-wrap justify-content-start md:justify-content-between">
    <ng-template pTemplate="start">
      <img
        routerLink="/scubamedic"
        src="https://imgs.search.brave.com/vbYEL6hseyfdPFudj8GyGa6CwDqnB37CX54koxFgaeU/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzNiLzA0/L2U0LzNiMDRlNGUw/MThiMTk1NmY4MzA0/MmQzMzY4MTUzNGJi/LmpwZw"
        alt="Logotipo Scubamedic - Seguros de buceo"
        class="logo_principal img-responsive mr-2 w-10rem sm:w-7rem cursor-pointer" />


      <!-- <span class="text-lg">Consultores SegurSub</span> -->
    </ng-template>
    <ng-template pTemplate="end">
      <app-cart></app-cart>
    </ng-template>
  </p-menubar>
</section>
